import cn from "classnames"

import style from "modules/PsyProfile/components/WhiteBookingBlock/style.module.scss"
import { Psychologist } from "utils/interfaces"
import { NewBookingPageLink } from "app/AppRouter/links"
import { isBookingAvailable } from "utils/bookingAvailable"
import { Text } from "ui-kit/components-branded/Text"
import { Box } from "ui-kit/components-branded/Box"
import { Img } from "ui-kit/components-branded/Img"

interface Props {
    psy: Psychologist
    query: Record<string, string>
    position: string
}

export function WhiteBookingBlock({ psy, query, position }: Props) {
    const bookingAvailable = isBookingAvailable(psy)
    if (!bookingAvailable) return null
    return (
        <section className={style.container}>
            <Box className={style.box}>
                <div className={style.content}>
                    <Text
                        className={style.title}
                        isAccent
                        data-testid="psy-profile-sign-today-title"
                    >
                        Запишитесь сегодня
                    </Text>
                    <Text>
                        Удобное для&nbsp;вас время записи на&nbsp;сессию онлайн или&nbsp;лично.
                    </Text>
                </div>
                <div className={style.preview}>
                    <Img src="select-therapist-illustration-first.svg" />
                </div>
                <NewBookingPageLink
                    hashId={psy.hash_id}
                    query={query}
                    position={position}
                    className={cn("b-button button--regular", style.button)}
                    data-testid="psy-profile-sign-today-pick-time"
                >
                    Посмотреть время
                </NewBookingPageLink>
            </Box>
        </section>
    )
}
